import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import styled from 'styled-components'
// import { Editor } from 'slate-react'

import Card from '@hixme-ui/card'
import Container from '@hixme-ui/container'
import Text from '@hixme-ui/text'
import { Button } from '@hixme-ui/forms'
import { Row, Col } from 'react-flexbox-grid'

import { TagsEditorContainer, TagsViewerContainer } from '../../tags/containers'
import { NOTE_TYPE } from '../constants'

const TagContainer = styled(Text)`
  background-color: #eff6f8;
  padding: 10px 20px 10px 20px;
  width: 100%;
`

const NoteCard = ({
  closeEditTags,
  expandNote,
  isAdmin,
  isExpanded,
  isEditing,
  isUpdating,
  isChanged,
  isLoaded,
  note,
  toggleEditTags,
  value,
}) => (
  <Card noPadding margin="0 20px 20px 20px">
    <Container>
      <Row>
        <Col xs={10}>
          <Container
            noPadding
            style={{
              width: '100%',
            }}
          >
            <Text light thin small>
              {moment(note.CreatedDate).format('dddd, MMMM Do YYYY, h:mm:ss a')}{' '}
              |{' '}
            </Text>
            <Text light thin small>
              {note.AuthorFirstName} {note.AuthorLastName}
              {isAdmin && ' (Admin)'} |{' '}
            </Text>
            <Text light thin small>
              {note.ContactMethod && note.ContactMethod}
              {note.TimeInMinutes && ` / ${note.TimeInMinutes} min`}
              {note.Outcome && ` / ${note.Outcome}`}
            </Text>
          </Container>
        </Col>
        <Col xs={2} style={{ textAlign: 'right' }}>
          <Text
            small
            a
            blue
            tabIndex={-1}
            onClick={expandNote(note.Id, !isExpanded)}
          >
            {isExpanded ? 'Collapse' : 'Expand'}
          </Text>
        </Col>
      </Row>
    </Container>
    {isExpanded && <Container>{value}</Container>}
    {isEditing ? (
      <Container
        width="100%"
        padding="10px 0"
        style={{
          backgroundColor: '#eff6f8',
        }}
      >
        <Container flex noPadding>
          <TagsEditorContainer Id={note.Id} ItemType={NOTE_TYPE} />
        </Container>
        <Container textCenter padding="0 20px" margin="0">
          {isUpdating && <Text>Updating Tags...</Text>}
          {!isUpdating && (
            <Button secondary onClick={closeEditTags}>
              {isChanged ? 'Close and save tags' : 'Close tags'}
            </Button>
          )}
        </Container>
      </Container>
    ) : (
      <TagContainer a onClick={toggleEditTags}>
        <Container
          flex
          noPadding
          justifyContent="space-between"
          alignItems="baseline"
        >
          <Container flex noPadding>
            <TagsViewerContainer Id={note.Id} ItemType={NOTE_TYPE} />
          </Container>
          <Container flex noPadding>
            {isLoaded && (
              <Text smaller thin light key="editTags">
                Edit tags
              </Text>
            )}
          </Container>
        </Container>
      </TagContainer>
    )}
  </Card>
)

NoteCard.propTypes = {
  closeEditTags: PropTypes.func.isRequired,
  expandNote: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  isExpanded: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool,
  isChanged: PropTypes.bool,
  isLoaded: PropTypes.bool,
  isUpdating: PropTypes.bool,
  note: PropTypes.object.isRequired,
  toggleEditTags: PropTypes.func,
  value: PropTypes.object.isRequired,
}

NoteCard.defaultProps = {
  isAdmin: false,
  isEditing: false,
  isChanged: false,
  isLoaded: false,
  isUpdating: false,
  isUpdatingTags: false,
  tagsBeingEdited: null,
  toggleEditTags: null,
}

export default NoteCard
